<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>
<div class="row" *ngIf="loaded">
  <div class="col-12"><small class="text-center align-self-center">
    <i class="text-danger">* indicates mandatory field</i> &nbsp;
    <i class="fas fa-question-circle" placement="top"></i> &nbsp;
    <a target="_blank" [routerLink]="['/dashboard/support/msg-template']">View template field description</a>
  </small></div>
  <div class="col-12 text-right align-self-center">
    <button class="btn btn-default mr-2" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()">Save</button>
  </div>
  <div class="col-12">
    <dl class="row">
      <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> ShortCode :</dt>
      <dd class="col-4">
          <input type="text" [(ngModel)]="msgData.shortCode" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Language :</dt>
      <dd class="col-4">
          <input type="text" [(ngModel)]="msgData.lang" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Invalid Sub: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.subInvalidMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Invalid Sub: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.unsubInvalidMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Sub Help: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.subHelpMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Unsub Help: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.unsubHelpMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">UnSub All: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.unsubAllMsg" class="form-control" />
      </dd>
    </dl>
  </div>
</div>

